import Box from '@mui/material/Box';
import useEmailSettings from './hooks/email-settings.hooks';
import { CustomerDetail } from '../../../../features/users/views/CustomerDetailsTable';
import StandardButton from '../../../components/Button/StandardButton';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { useMemo } from 'react';
import ResetEmailSettings from './ResetEmailSettings';

type TestEmailButtonProps = {
    data: CustomerDetail;
    onUpdate: (data: CustomerDetail) => void;
};

const TestEmailButton = ({ data, onUpdate }: TestEmailButtonProps) => {
    const { sendTestEmail, isDisabled } = useEmailSettings();

    const disabled = useMemo(() => {
        return isDisabled(data);
    }, [isDisabled, data]);

    const handleSendEmailTest = async () => {
        try {
            await sendTestEmail(data);

            alert('Test email sent.');
        } catch {
            alert('Failed to send test email');
        }
    };

    return (
        <Box>
            <StandardButton onClick={handleSendEmailTest} icon={<ForwardToInboxIcon />} fullWidth disabled={disabled}>
                Test Email
            </StandardButton>

            {!disabled && <ResetEmailSettings data={data} onUpdate={onUpdate} />}
        </Box>
    );
};

export default TestEmailButton;
